import './ActionGroup.css';
export var actionGroupHiddenItemCSS = '_1auoqao0-2-0-1';